<!--
Author: TangChen
Date: 2018-10-31
Desc: 风险评测管理组件，由index.js 配置引入
-->
<template>
    <div>
        <comp-title-dc back-url-name="acctManager">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/home' }">我的账户</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/acctManager' }">账户管理</el-breadcrumb-item>
                <el-breadcrumb-item>风险测评</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title-dc>
        <div :class="'bizcomp-risk bizcomp ' + className">
            <div class="bizcomp-risk-header">
                <div class="risk-header-title">风险测评</div>
                <div class="risk-header-text">
                    根据《证券期货投资者适当性管理办法》投资前请填写风险测评问卷
                </div>
            </div>
            <div class="rules-contain cursor-pointer" v-on:click="showRuleFn">
                <i class="el-icon-info warn-blue"></i>
                <div class="rules-text">查看《投资者适当性匹配规则》</div>
            </div>
            <el-row>
                <!-- <el-col :span="24" class="risklevel">
                您的风险等级： <span>{{ !$util.isEmpty(risklevel)?$cache.getDict('100017',risklevel):'未做风险评测' }}</span>
            </el-col> -->
                <el-col :span="24">
                    <div class="risk-msg">
                        <div v-if="riskInfo" class="lineF clear">
                            <div v-for="(btn, index) in riskInfo" :key="index" class="boxF">
                                <div class="boxS" :class="notIE9 ? '' : 'ie-low'">
                                    <div
                                        class="boxT"
                                        :class="
                                            risklevel && btn.tit === risklevel
                                                ? 'yel'
                                                : risklevel && Number(btn.tit - 1) === Number(risklevel)
                                                ? 'blue'
                                                : ''
                                        "
                                    >
                                        <div class="overlay">
                                            <span v-if="btn.tit !== '0'">
                                                {{
                                                    $cache.getDict("100017", btn.tit, false) +
                                                    "(C" +
                                                    btn.tit +
                                                    ")"
                                                }}
                                            </span>
                                            <span v-else class="low-risk">最低风险等级(C0)</span>
                                            <p v-if="btn.tit !== '0'">
                                                {{ $cache.getDict("110143", btn.tit) }}
                                            </p>
                                            <div v-else-if="lowriskCanBuy" class="low-risk-desc">
                                                <p>低风险（R1）</p>
                                                <p>不允许购买风险错配产品</p>
                                            </div>
                                            <p v-else>禁止购买任意产品</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="risklevel.trim()" class="risk-info">
                            <!-- {{ $util.getRiskTest(risklevel) }} -->
                            <span>尊敬的投资者：</span>
                            <br />
                            <span>
                                &emsp;&emsp;您的风险承受能力为：{{
                                    $cache.getDict("100017", risklevel)
                                }}，依据我司的投资者与产品、服务风险等级匹配规则，您的风险承受能力等级{{
                                    getMatchedProduct
                                }}。
                            </span>
                            <span>
                                我司在此郑重提醒，我司向您销售的产品或提供的服务将以您的风险承受能力等级和投资品种、期限为基础，
                                <span>
                                    若您提供的信息发生任何重大变化，您应当及时以书面方式通知我司。
                                </span>
                                我司建议您审慎评判自身风险承受能力、结合自身投资行为，认真填写投资品种、期限，并做出审慎的投资判断。
                            </span>
                        </div>
                        <div v-else class="risk-info">尚未评测</div>
                    </div>
                </el-col>
                <el-col :span="24" class="risk-other">
                    <div class="btn-group">
                        <div style="display: inline-flex; flex-direction: column">
                            <button
                                v-if="$util.getConfig().hideFunc"
                                class="risk-btn"
                                v-on:click="checkRisk(continueTest)"
                            >
                                {{ !$util.isEmpty(risklevel) ? "重新" : "立即" }}测评
                            </button>
                            <el-button
                                v-if="showLastResult"
                                type="text"
                                style="width: 180px"
                                v-on:click="lastResultClick"
                            >
                                沿用上一次测评结果
                            </el-button>
                        </div>
                        <button
                            v-if="!$util.isEmpty(risklevel) && $util.getConfig().hideFunc"
                            class="back-btn"
                            v-on:click="continueRisk"
                        >
                            返回
                        </button>
                    </div>
                    <span v-if="!fn && !$util.hideSdx()">
                        <p>为了便于金融机构更好地为您提供适当性服务，请您</p>
                        <p
                            class="info-collection"
                            v-on:click.once="$router.push({ name: 'infocollection' })"
                        >
                            查看信息补录
                        </p>
                    </span>
                </el-col>
            </el-row>
            <!-- <el-dialog
                title="风险变动提示"
                :visible.sync="dialogVisible"
                class="prop"
                width="420px"
            >
                <div class="info-box">
                    <el-alert
                        title="由于您的风险等级发生调整，系统需要您对已签订的定期投资协议或预约交易进行适当性处理，对于未处理的定期投资协议或预约交易，将不产生定投交易或预约交易申请。"
                        type="warning"
                        show-icon
                        :closable="false"
                    />
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" v-on:click.once="$router.push({ name: 'home' })">
                        前往处理
                    </el-button>
                    <el-button v-on:click="dialogVisible = false">我已知晓</el-button>
                </div>
            </el-dialog> -->
            <my-dialog
                title="提示"
                :visible.sync="dialogVisible"
                :dialog-close="dialogClose"
                width="600px"
            >
                <div class="warn-detail">
                    由于您的个人风险等级或产品风险等级变动，存在({{
                        warnNum
                    }})笔产品风险等级高于您的风险承受能力的交易，请前往进行适当性处理。
                </div>
                <div class="align-c">
                    <el-button type="primary" style="width: 180px" v-on:click="toWarnDetail">
                        确认
                    </el-button>
                </div>
            </my-dialog>
        </div>
        <div>
            <risk-rule :show-rule-comp="showRule" v-on:dialog-close="dialogCloseFn"></risk-rule>
        </div>
        <footer-questions
            v-if="$const.warmReminderDisplay"
            class="footer-questions"
            :common-question="commonQuestion"
            :warning-html="warningHtml"
        ></footer-questions>
        <last-risk-confirm
            :risk-level="risklevel"
            :visible="lastDialogVisible"
            v-on:cancel="handleCancel"
            v-on:confirm="handleConfirm"
        ></last-risk-confirm>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import fundApi from "@/api/fund";
import userApi from "@/api/user";
import RiskRule from "@/bizcomponents/acctManager/riskRule.vue";
import myDialog from "@/components/layout/myDialog.vue";
import footerQuestions from "@/components/layout/footerQuestions.vue";
import warningHtml from "@/constant/warning_html.js";
import LastRiskConfirm from "./lastRiskConfirm.vue";

export default {
    name: "RiskInfo",
    components: {
        LastRiskConfirm,
        RiskRule,
        myDialog,
        footerQuestions
    },
    mixins: [mixin],
    props: {
        fn: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            notIE9: true,
            info: {},
            warnNum: 0, // 适当性处理数量
            lastDialogVisible: false,
            riskInfo: [
                {
                    tit: "0"
                },
                {
                    tit: "1"
                },
                {
                    tit: "2"
                },
                {
                    tit: "3"
                },
                {
                    tit: "4"
                },
                {
                    tit: "5"
                }
            ],
            lowriskCanBuy: false,
            iswarn: "",
            dialogVisible: false,
            showRule: false,
            warningHtml: "",
            commonQuestion: [],
            checkRiskInfo: {},
            assettype: "",
            risklevel: "",
            showLastResult: false
        };
    },
    computed: {
        getMatchedProduct() {
            if (this.risklevel === "0") {
                return this.lowriskCanBuy
                    ? "与我司低风险产品（不允许购买风险错配产品）相匹配"
                    : "禁止购买任意产品";
            }
            let productRisk = this.$cache.getDict("110143");
            let matchedRisk = productRisk.filter((item) => item.subitem <= this.risklevel);
            let res = "";
            matchedRisk.forEach((item) => (res += item.subitemname + "风险、"));
            return "与我司" + res.substring(0, res.length - 1) + "产品相匹配";
        }
    },
    created() {
        this.riskInfo = this.$cache
            .getDict("100017")
            .sort((a, b) => a.subitem - b.subitem)
            .map((item) => {
                return {
                    ...item,
                    tit: item.subitem
                };
            });
        this.lowriskCanBuy = this.$cache.getCompanyInfoParam("6000016") !== "1"; // 命中最低风测答案风险等级为0无风险,选否则可以购买R1
        const theUA = window.navigator.userAgent.toLowerCase();
        if (
            (theUA.match(/msie\s\d+/) && theUA.match(/msie\s\d+/)[0]) ||
            (theUA.match(/trident\s?\d+/) && theUA.match(/trident\s?\d+/)[0])
        ) {
            const ieVersion =
                theUA.match(/msie\s\d+/)[0].match(/\d+/)[0] || theUA.match(/trident\s?\d+/)[0];
            if (ieVersion === "9") {
                this.notIE9 = false;
            }
        }
        this.info = this.$cache.getUser();
        this.iswarn = this.$route.query.iswarn || "";
        this.riskAgree();
        this.warningHtml = warningHtml.warningHtml14;
        this.assettype = this.$route.query.assettype || "2";
        this.risklevel = this.$route.query.risklevel || this.$cache.getUser().risklevel || "";
        this.getCheckRiskInfo();
    },
    mounted() {
        this.showLastResult = this.$cache.getCompanyInfoParam("10102038") === "1";
    },
    methods: {
        showRuleFn() {
            this.showRule = true;
        },
        dialogCloseFn(value) {
            this.showRule = false;
        },
        async getCheckRiskInfo() {
            let assettype = this.$util.getParamValue("1000056");
            const res = await userApi.checkRiskInfo({
                custno: this.info.custno,
                assettype: assettype.indexOf(this.assettype) > -1 ? this.assettype : "*"
            });
            this.checkRiskInfo = res.data;
        },
        checkRisk(callback) {
            // this.checkRiskInfo.driskcounttremainflag = "1"; // 临时代码
            // this.checkRiskInfo.yriskcounttremainflag = "1"; // 临时代码
            if (this.checkRiskInfo.riskcountlimitflag === "1") {
                if (this.checkRiskInfo.firstriskflag === "1") {
                    callback();
                } else if (this.checkRiskInfo.riskexpireflag === "1") {
                    callback(); // 执行回调
                } else if (this.checkRiskInfo.yriskcounttremainflag !== "1") {
                    this.$message.warning(
                        "尊敬的投资者，您好，您该年度已无可用风测次数，请联系客服！"
                    );
                } else if (this.checkRiskInfo.driskcounttremainflag !== "1") {
                    this.$message.warning(
                        "尊敬的投资者，您好，您今日已无可用风测次数，请改日再测！"
                    );
                } else {
                    callback(); // 执行回调
                }
            } else {
                callback(); // 执行回调
            }
        },
        // 协议弹窗处理
        continueTest() {
            if (!this.fn) {
                this.$router.push({
                    name: "risktest",
                    query: {
                        firstriskdayflag: this.checkRiskInfo.firstriskdayflag,
                        assettype: this.assettype,
                        risklevel: this.risklevel
                    }
                });
            }
            if (this.fn) {
                this.$emit("risk-test-continue");
            }
        },
        async riskAgree() {
            if (!this.fn && this.iswarn === "1") {
                this.getSuitableList();
            }
        },
        // 获取待处理协议列表
        async getSuitableList() {
            if (!this.$cache.getBinded()) {
                return;
            }
            const res = await userApi.getSuitableList();
            if (res.data) {
                this.warnNum = res.data.total;
                if (this.warnNum > 0 && this.$util.getConfig().hideFunc) {
                    console.log("1111111");
                    this.dialogVisible = true;
                }
                this.$store.commit("updateSuitableList", res.data.data);
            }
        },
        // 关闭弹窗
        dialogClose() {
            this.dialogVisible = false;
        },
        // 跳转到待处理协议列表
        toWarnDetail() {
            this.dialogVisible = false;
            this.$router.push("/warnList");
        },
        continueRisk() {
            // 风险沿用
            /* const _this = this;
            this.$util.request("acct/risksurvey/answer", { iscontinue: "0" }, "POST").then(res => {
                if (res.data) {
                    const info = _this.$cache.getUser();
                    info.riskexpired = "0";
                    info.risklevel = res.data[0].risklevel;
                    _this.$store.dispatch("setInfo", info).then(() => {
                        _this.iswarn = res.data[0].iswarn;
                        _this.riskAgree();
                    });
                }
            }); */
            if (this.fn) {
                this.$emit("fn-back", true);
            } else {
                this.$router.push({ name: "fund" });
            }
        },
        handleCancel() {
            this.lastDialogVisible = false;
        },
        handleConfirm(flag) {
            if (flag) {
                this.checkRisk(this.useLastResult());
            }
            this.handleCancel();
        },
        lastResultClick() {
            this.lastDialogVisible = true;
        },
        async useLastResult() {
            let assettype = this.$util.getParamValue("1000056");
            const res = await userApi.selectQuestionAndOption({
                invtp: this.$cache.getUser().invtp,
                status: "0",
                assettype: assettype.indexOf(this.assettype) > -1 ? this.assettype : "*",
                papertype: "0"
            });
            if (res.data && res.data.length > 0) {
                const { answer, papercode, pointlist } = this.extractLastRiskAnswerAndPoint(
                    res.data
                );
                const _this = this;
                let assettype = this.$util.getParamValue("1000056");
                const rs = await userApi.combCustRiskService({
                    answer,
                    pointlist,
                    papercode,
                    iscontinue: "1",
                    assettype: assettype.indexOf(_this.assettype) > -1 ? _this.assettype : "*"
                });
                if (rs.code == "0") {
                    this.$cache.refreshUser();
                }
            } else {
                this.$message({
                    type: "error",
                    message: "沿用上一次测评结果失败！"
                });
            }
        },
        /**
         * 从风测题库数据中提取上一次答案+对应分数，拼接成接口所需完整格式
         * 兼容单选/多选，自动匹配resultList中result对应的resultpoint
         * @param {Array} questionList 后台返回的题库数组（含myanswer/resultList/multselect）
         * @returns {Object} 风测接口提交参数 { answer, pointlist, papercode }
         */
        extractLastRiskAnswerAndPoint(questionList) {
            // 1. 基础入参校验，防止空数据/非数组报错
            if (!Array.isArray(questionList) || questionList.length === 0) {
                console.error("提取风测答案失败：题库数据为空或非数组格式");
                return { answer: "", pointlist: "", papercode: "" };
            }

            // 2. 提取唯一试卷编号（所有题目papercode一致，取第一个有效值）
            const papercode = questionList[0].papercode || "";
            // 存储单题的answer和point片段，最终拼接
            const answerFragments = [];
            const pointFragments = [];

            // 3. 遍历每道题，解析答案和对应分数
            questionList.forEach((question) => {
                // 跳过无题编码、无答案、无选项列表的异常题目
                if (
                    !question.questioncode ||
                    !question.myanswer ||
                    !Array.isArray(question.resultList)
                ) {
                    console.warn("跳过异常风测题目：缺少题编码/答案/选项列表", question);
                    return;
                }

                const { questioncode, myanswer, resultList } = question;
                // 分割答案：多选以英文逗号分隔（如"B,C"→["B","C"]），单选直接转数组（如"A"→["A"]）
                const answerArr = myanswer.split(",").map((item) => item.trim());
                // 存储当前题的所有对应分数
                const currentPointArr = [];

                // 4. 匹配每个答案对应的分数（resultpoint）
                answerArr.forEach((answer) => {
                    // 从resultList中找到result与答案匹配的项，取其resultpoint
                    const matchItem = resultList.find((item) => item.result === answer);
                    if (matchItem && matchItem.resultpoint !== undefined) {
                        currentPointArr.push(matchItem.resultpoint);
                    } else {
                        console.warn(`风测题目${questioncode}的答案${answer}未找到对应分数`);
                    }
                });

                // 5. 过滤无分数的异常项，仅保留有效数据
                if (currentPointArr.length === 0) {
                    console.warn(`风测题目${questioncode}无有效分数，跳过`);
                    return;
                }

                // 6. 拼接单题片段：题编码:答案（如"1:A"、"2:B,C"）
                answerFragments.push(`${questioncode}:${myanswer}`);
                // 拼接单题分数片段：分数用英文逗号分隔（如"1"、"2,3"）
                pointFragments.push(currentPointArr.join(","));
            });

            // 7. 拼接最终的answer和pointlist，竖线分隔所有题目
            const answer = answerFragments.join("|");
            const pointlist = pointFragments.join("|");

            // 8. 返回接口所需完整参数
            return {
                answer,
                pointlist,
                papercode
            };
        }
    }
};
</script>
<style lang="scss" scoped>
@import "../../assets/css/varibles";
.bizcomp-risk {
    padding-bottom: 20px;
    .bizcomp-risk-header {
        display: flex;
        .risk-header-title {
            padding: 17px 8px 21px 20px;
            font-family: Source Han Sans CN;
            font-size: 20px;
            font-weight: 500;
            color: var(--color-text-primary);
        }
        .risk-header-text {
            padding: 22px 0;
            font-family: Roboto;
            font-size: 16px;
            font-weight: normal;
            color: var(--color-text-regular);
        }
    }
    .rules-contain {
        display: flex;
        align-items: center;
        height: 40px;
        border-radius: 4px;
        // background-color: rgba(224, 234, 255, 0.5);
        background-color: var(--color-accent);
        .warn-blue {
            color: var(--color-primary);
            font-size: 22px;
            margin-left: 20px;
        }
        .rules-text {
            margin-left: 8px;
            font-size: 14px;
            font-weight: normal;
            color: var(--color-primary);
            opacity: 1;
            font-family: Source Han Sans CN;
        }
    }
    .cursor-pointer {
        cursor: pointer;
    }
    .risklevel {
        font-size: $f16;
        color: $text-color1;
        text-align: center;
        line-height: 50px;
        margin-top: 30px;
        span {
            font-size: $f22;
            color: $color-b;
        }
    }
    .risk-info {
        font-size: $f16;
        color: $text-color1;
        line-height: 24px;
        margin-top: 20px;
        text-align: justify;
    }
    .risk-msg {
        position: relative;
        width: 1080px;
        margin: 20px auto 46px;
        .boxF,
        .boxS,
        .boxT,
        .overlay {
            width: 180px;
            height: 240px;
            overflow: hidden;
        }
        .overlay {
            padding: 40px 20px 40px;
            display: flex;
            align-items: center;
            flex-direction: column;
            justify-content: center;
        }
        .low-risk {
            font-size: $f16;
        }
        .low-risk-desc {
            line-height: 24px;
        }
        .boxF:not(:first-child) .boxT {
            &:before,
            &:after {
                top: -1px;
                border-bottom: 58px solid $border-color4;
                border-left-width: 29px;
                border-right-width: 29px;
            }
        }
        .boxF .boxT {
            background-color: $bg15;
            &.yel {
                background-color: $color-b;
                &:before,
                &:after {
                    border-bottom-color: $color-a-s;
                }
            }
            &.blue {
                &:before,
                &:after {
                    border-bottom-color: $bg8;
                }
            }
        }
    }
    .risk-other {
        text-align: center;
        line-height: 30px;
        .risk-btn {
            width: 180px;
            height: 42px;
            border-radius: 2px;
            background: var(--color-primary);
            font-size: 16px;
            font-weight: 500;
            text-align: center;
            color: #ffffff;
            border: 1px solid var(--color-primary);
            cursor: pointer;
            margin-right: 40px;
        }
        .back-btn {
            width: 180px;
            height: 42px;
            border-radius: 2px;
            background: var(--color-border-base);
            font-size: 16px;
            text-align: center;
            color: var(--color-text-regular);
            border: 1px solid var(--color-border-base);
            cursor: pointer;
        }
        .el-button {
            width: 150px;
            &.border-blue {
                border-color: $color-b;
                color: $color-b;
            }
        }
        .el-button + .el-button {
            margin-left: 24px;
        }
        p {
            color: $text-color1;
            margin-top: 40px;
            &.info-collection {
                margin-top: 5px;
                color: var(--color-primary);
                text-align: center;
                cursor: pointer;
            }
        }
    }
}
.warn-detail {
    padding: 50px 20px;
    font-size: 16px;
    text-align: center;
}
</style>
